// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AdviserHoverWrapper-module__wrapper___elc22{cursor:help;display:inline-block}", "",{"version":3,"sources":["webpack://./src/features/adviser/AdviserHoverWrapper/AdviserHoverWrapper.module.scss"],"names":[],"mappings":"AAAA,6CACE,WAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "AdviserHoverWrapper-module__wrapper___elc22"
};
export default ___CSS_LOADER_EXPORT___;
